import Menu from "components/common/Menu";
import SearchBar from "components/common/SearchBar";
import AppCopy from "copy/AppCopy";
import React, { useEffect, useState } from "react";
import { CommonStyles } from "styles/CommonStyles";
import { useTabActive } from "hook/useTabActive";
import { SideBarTabs } from "constants/tabs";
import StaffHeader from "components/header/StaffHeader";
import StaffCard from "components/card/StaffCard";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Paths } from "router/Paths";
import useAdminOnly from "hook/useAdminOnly";
import { useSelector } from "react-redux";
import { RootState } from "app/store";
import useUser from "hook/useUser";
import { UserType } from "types/loadedData";
import PageHeader from "components/common/PageHeader";
import EmptyState from "components/common/EmptyState";

function StaffPage() {
  const navigate = useNavigate();
  const { staffs } = useSelector((state: RootState) => state.user);
  const { getStaff } = useUser();
  const [searchValue, setSearchValue] = useState<string>("");
  const [loadedStaff, setLoadedStaff] = useState<UserType[]>(staffs);

  const loadData = async () => {
    await getStaff({});
  };

  useAdminOnly();

  useTabActive(SideBarTabs.Staff.name);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    setLoadedStaff(staffs);
  }, [staffs]);

  const handleOnSearchValueChange = (e: any) => {
    setSearchValue(e.target.value);
  };

  const handleSearchKeydown = (e: any) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    if (searchValue) {
      let filteredStaff = staffs.filter(
        (staff) =>
          (staff.name &&
            staff.name
              .toLocaleLowerCase()
              .includes(searchValue.toLocaleLowerCase())) ||
          (staff.email &&
            staff.email
              .toLocaleLowerCase()
              .includes(searchValue.toLocaleLowerCase())) ||
          (staff.phoneNumber && staff.phoneNumber.includes(searchValue))
      );
      setLoadedStaff(filteredStaff);
    } else {
      setLoadedStaff(staffs);
    }
  };

  const handleCreateStaff = () => {
    navigate(Paths.createStaff);
  };

  const { searchPlaceholder, titleText } = AppCopy.staffPage;

  return (
    <div className={`${CommonStyles.pageWrapper} `}>
      <Menu />
      <PageHeader
        title={titleText}
        description="Manage staff access and account status."
        actions={
          <button
            type="button"
            onClick={handleCreateStaff}
            className={ClassName.addButton}
          >
            <FaPlus size={13} />
            Add staff
          </button>
        }
      />
      <div className={ClassName.container}>
        <SearchBar
          onKeyDown={handleSearchKeydown}
          onSearch={handleSearch}
          value={searchValue}
          onChange={handleOnSearchValueChange}
          placeholder={searchPlaceholder}
        />
        <section className={ClassName.section}>
          <StaffHeader />
          <div className={ClassName.list}>
            {loadedStaff.map((user) => (
              <StaffCard key={String(user._id)} staff={user} />
            ))}
            {!loadedStaff.length ? (
              <EmptyState
                title="No staff found"
                description="Try a different name, email, or phone number."
              />
            ) : null}
          </div>
        </section>
      </div>
    </div>
  );
}

export default StaffPage;

const ClassName = {
  container: "flex flex-col gap-3 text-primaryText",
  section:
    "flex min-h-0 flex-1 flex-col rounded-2xl border border-slate-200 bg-white p-4",
  list: "max-h-[calc(100vh-260px)] min-h-56 overflow-y-auto",
  addButton:
    "inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-primary px-4 text-sm font-semibold text-white hover:opacity-90",
};
